(function() {
  var elems = document.querySelectorAll('.ph-savedlist__date');

  for (var i = 0; i < elems.length; i = i + 1) {
    var e = elems[i],
        time = e.getAttribute('utctime'),
        locale = $('.ph-localtime__locale').html();
    var options = {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    };
    var date = new Date(time);

    if (isNaN(date) === false) {
      e.innerHTML = date.toLocaleString(locale, options);
    }
  }
})();
